export default __webpack_public_path__ + "static/media/52t.af0acb7f.jpg";